import useResource from "./useResource"

export default function useDealAsset(dealAssetId) {
  const key = dealAssetId ? `/deal_assets/${dealAssetId}` : null

  const [dealAsset] = useResource({
    key,
    resourceType: "deal_asset",
  })

  if (!dealAsset) return

  function userCan(action) {
    return dealAsset.user_permissions[action]
  }

  dealAsset.userCan = userCan

  return dealAsset
}
